import axios from 'axios'
import store from '@/store/index'

/*global Toast*/
// 防抖使用的变量
let checkCodeTimer = true

// test
axios.interceptors.request.use(
  config => {
    // loading
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

axios.interceptors.response.use(
  response => {
    return response
  },
  error => {
    return Promise.resolve(error.response)
  }
)

function checkStatus(response) {
  // loading
  // 如果http状态码正常，则直接返回数据
  if (response) {
    return response
    // 如果不需要除了data之外的数据，可以直接 return response.data
  }
  // 异常状态下，把错误信息返回去
  // console.log('status: -404')
  return {
    status: -404,
    msg: '网络不稳定'
  }
}

function checkCode(res) {
  // 如果code异常(这里已经包括网络错误，服务器错误，后端抛出的错误)，可以弹出一个错误提示，告诉用户
  if (Number(res.status) === -404) {
    // Message({
    //     showClose: true,
    //     message: res.msg,
    //     type: 'error',
    //     duration: 2000
    // })
  }
  if (res.data) {
    if (
      Number(res.data.code) === -2 ||
      Number(res.data.code) === -4 ||
      Number(res.data.code) === -10011
    ) {
      if (checkCodeTimer) {
        checkCodeTimer = false
        Toast({
          showClose: true,
          message: res.data.message,
          type: 'error',
          duration: 2000
        })
        setTimeout(() => {
          checkCodeTimer = true
          store.commit('setSessionInfo', '')
          store.commit('marketStatusInNewTopline', '--')
          sessionStorage.clear()
          localStorage.removeItem('tq_login_value')
          localStorage.setItem('isLogin', false)
          // global.router.push('/login')
        }, 1000)
        // return new Promise(() => {}) // 这个也许可以终止 Promise的链式调用  可以防止具体页面报错(解决办法),但是实际可能会造成内存泄露哦
      }
    } else {
      return res
    }
    // console.log(res.data)
  } else {
    return res
  }
}
export default {
  gete(url) {
    return axios({
      method: 'get',
      url,
      timeout: 10000,
      dataType: 'jsonp',
      cache: 'false',
      crossDomain: true,
      withCredentials: false,
      headers: {
        'Accept-Language':
          localStorage.lang || navigator.language.slice(-2).toLowerCase(),
        terminalType: localStorage.getItem('equipmentFlag_PC') || 4
      }
    })
      .then(response => {
        return response
      })
      .then(res => {
        return res
      })
  },
  postFront(data) {
    console.log(store.state.common.sessionInfo)
    const firmId = store.state.common.sessionInfo.firmId
    const sessionStr = store.state.common.sessionInfo.sessionStr
    const userId = store.state.common.sessionInfo.userId
    let headersObj = {}
    if (userId && sessionStr && userId != null && sessionStr != null) {
      headersObj = {
        firmId: firmId,
        sessionStr: sessionStr,
        userId: userId,
        marketId: 3,
        terminalType: localStorage.getItem('equipmentFlag_PC') || 4
      }
    } else {
      headersObj = {
        terminalType: localStorage.getItem('equipmentFlag_PC') || 4
      }
    }
    // userId='100010';
    return axios({
      method: 'post',
      baseURL: window.g.APP_URL_PATH2,
      url: data.url,
      data: data.param,
      dataType: 'json',
      headers: headersObj,
      timeout: window.g.AXIOS_TIMEOUT
    })
      .then(response => {
        return checkStatus(response)
      })
      .then(res => {
        return checkCode(res)
      })
  },
  postFrontGood(data) {
    // const firmId = store.state.common.sessionInfo.firmId
    const sessionStr = store.state.common.sessionInfo.sessionStr
    const userId = store.state.common.sessionInfo.userId
    let headersObj = {}
    if (userId && sessionStr && userId != null && sessionStr != null) {
      headersObj = {
        // firmId: firmId,
        sessionStr: sessionStr,
        userId: userId,
        marketId: 3,
        terminalType: localStorage.getItem('equipmentFlag_PC') || 4
      }
    } else {
      headersObj = {
        firmId: -1,
        terminalType: localStorage.getItem('equipmentFlag_PC') || 4
      }
    }
    // userId='100010';
    return axios({
      method: 'post',
      baseURL: window.g.APP_URL_PATH2,
      url: data.url,
      data: data.param,
      dataType: 'json',
      headers: headersObj,
      timeout: window.g.AXIOS_TIMEOUT
    })
      .then(response => {
        return checkStatus(response)
      })
      .then(res => {
        return checkCode(res)
      })
  },
  postFile(data) {
    const userId = store.state.common.sessionInfo.userId
    const sessionStr = store.state.common.sessionInfo.sessionStr
    const options = {
      method: 'post',
      baseURL: window.g.APP_URL_PATH_UPLOAD,
      url: data.url,
      data: data,
      dataType: 'json',
      timeout: window.g.AXIOS_TIMEOUT
    }
    if (store.state.common.sessionInfo.isLogin === 'true') {
      options.headers = {
        'User-Id': userId,
        'Session-Str': sessionStr,
        terminalType: localStorage.getItem('equipmentFlag_PC') || 4
      }
    } else {
      // delete options.headers
      options.headers = {
        terminalType: localStorage.getItem('equipmentFlag_PC') || 4
      }
    }
    return axios(options)
      .then(response => {
        return checkStatus(response)
      })
      .then(res => {
        return checkCode(res)
      })
  },
  getRes(data) {
    const options = {
      method: 'get',
      baseURL: window.g.APP_URL_PATH2,
      url: data.url,
      params: data.param,
      dataType: 'json',
      timeout: window.g.AXIOS_TIMEOUT
    }
    if (store.state.common.sessionInfo.isLogin === 'true') {
      options.headers = {
        userId: store.state.common.sessionInfo.userId,
        sessionStr: store.state.common.sessionInfo.sessionStr,
        marketId: 3,
        terminalType: localStorage.getItem('equipmentFlag_PC') || 4
      }
    } else {
      // delete options.headers
      options.headers = {
        terminalType: localStorage.getItem('equipmentFlag_PC') || 4
      }
    }
    return axios(options)
      .then(response => {
        return checkStatus(response)
      })
      .then(res => {
        return checkCode(res)
      })
  },
  postNewJP(data) {
    // const userId = store.state.common.sessionInfo.userId
    const sessionStr = store.state.common.sessionInfo.sessionStr
    const userId = store.state.common.sessionInfo.userId
    let headersObj = {}
    if (userId && sessionStr && userId != null && sessionStr != null) {
      headersObj = {
        userId: userId,
        sessionStr: sessionStr,
        marketId: 3,
        terminalType: localStorage.getItem('equipmentFlag_PC') || 4
        // Authorization: userId + ',' + sessionStr + ',' + data.url
      }
    } else {
      headersObj = {
        terminalType: localStorage.getItem('equipmentFlag_PC') || 4
      }
    }
    return axios({
      method: 'post',
      baseURL: window.g.APP_JP_PATH,
      url: data.url,
      data: data.param,
      dataType: 'json',
      headers: headersObj,
      timeout: window.g.AXIOS_TIMEOUT
    })
      .then(response => {
        return checkStatus(response)
      })
      .then(res => {
        return checkCode(res)
      })
  },
  getNewPath2(data) {
    const sessionStr = store.state.common.sessionInfo.sessionStr
    const userId = store.state.common.sessionInfo.userId
    let url = window.g.APP_URL_PATH2 + data.url
    // const firmId = store.state.common.sessionInfo.firmId
    if (data.param) {
      Object.keys(data.param).forEach(function(key, i) {
        if (i === 0) {
          url += '?' + key
        } else {
          url += '&' + key
        }
        url += '=' + data.param[key]
      })
    }
    return axios({
      method: 'get',
      url,
      timeout: window.g.AXIOS_TIMEOUT,
      dataType: 'jsonp',
      cache: 'false',
      crossDomain: true,
      headers: {
        sessionStr: sessionStr,
        userId: userId,
        marketId: 3,
        terminalType: localStorage.getItem('equipmentFlag_PC') || 4,
        'Accept-Language':
          localStorage.lang || navigator.language.slice(-2).toLowerCase()
      },
      withCredentials: false
      // headers: {
      //   'Access-Control-Allow-Origin': '*',
      //   'Access-Control-Allow-Methods': 'POST, PUT, DELETE, GET, OPTIONS',
      //   'Access-Control-Allow-Headers':
      //     'Origin, X-Requested-With, Content-Type, Accept, Authorization'
      // }
    })
      .then(response => {
        return response
      })
      .then(res => {
        return res
      })
  }
}
